import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../api/client';
import { API_BASE_URL } from '../../config/api';
import friedRiceRaitaImg from '../../assets/images/fried-rice-raita.png';
import mirchiBajjiImg from '../../assets/images/mirchi-bajji.png';
import chapathiImg from '../../assets/images/chapathi.png';

const FALLBACK_DISHES = [
  {
    layout: 'large',
    theme: 'amber',
    headline: 'MEET, EAT & ENJOY THE TRUE TASTE',
    name: '',
    subtitle: 'Medium Spiced Fried Rice Paired with Refreshing Raita.',
    price: 'Rs. 199/-',
    cta_text: 'ORDER NOW',
    cta_link: '/our-menu',
    absolute_image_url: friedRiceRaitaImg,
  },
  {
    layout: 'compact',
    theme: 'green',
    headline: 'DISCOVER\nNEW MENU',
    name: 'Mirchi Bajji 4 Pieces',
    subtitle: '',
    price: 'Rs. 79/-',
    absolute_image_url: mirchiBajjiImg,
  },
  {
    layout: 'compact',
    theme: 'red',
    headline: 'BUY ONE\nGET ONE',
    name: '2 Soft and Fluffy\nWheat Chapathi\nWith Veg Curry',
    subtitle: '',
    price: 'Rs. 139/-',
    absolute_image_url: chapathiImg,
  },
];

function Multiline({ text }) {
  if (!text) return null;
  const lines = String(text).split('\n');
  return (
    <>
      {lines.map((line, index) => (
        <React.Fragment key={`${line}-${index}`}>
          {index > 0 ? <br /> : null}
          {line}
        </React.Fragment>
      ))}
    </>
  );
}

function themeClass(theme) {
  if (theme === 'green') return 'fd-card--green';
  if (theme === 'red') return 'fd-card--red';
  return 'fd-card--amber';
}

const HomeFeaturedDishes = () => {
  const [dishes, setDishes] = useState(FALLBACK_DISHES);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get(`${API_BASE_URL}/api/web-featured-dishes/active`);
        const rows = Array.isArray(data?.data) ? data.data : [];
        if (!cancelled && rows.length) setDishes(rows);
      } catch {
        /* keep fallback */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const large = dishes.find((item) => item.layout === 'large') || dishes[0];
  const stacked = dishes.filter((item) => item !== large);

  if (!large) return null;

  return (
    <section className="featured-dishes">
      <div className="container">
        <div className="fd-grid">
          <div className={`fd-card fd-card--large ${themeClass(large.theme)}`}>
            {large.absolute_image_url ? (
              <div className="fd-card__img">
                <img src={large.absolute_image_url} alt={large.name || large.headline} />
              </div>
            ) : null}
            <div className="fd-card__body">
              <h2 className="fd-card__title">
                <Multiline text={large.headline} />
              </h2>
              {large.subtitle ? <p className="fd-card__sub section-para">{large.subtitle}</p> : null}
              {large.price ? <p className="fd-card__price">{large.price}</p> : null}
              {large.cta_text && large.cta_link ? (
                <Link to={large.cta_link} className="btn-primary">
                  {large.cta_text}
                </Link>
              ) : null}
            </div>
          </div>

          {stacked.length ? (
            <div className="fd-stack">
              {stacked.map((item) => (
                <div key={item.id || item.headline} className={`fd-card ${themeClass(item.theme)}`}>
                  {item.absolute_image_url ? (
                    <div className="fd-card__img">
                      <img src={item.absolute_image_url} alt={item.name || item.headline} />
                    </div>
                  ) : null}
                  <div className="fd-card__body">
                    {item.headline ? (
                      <p className="fd-card__label">
                        <Multiline text={item.headline} />
                      </p>
                    ) : null}
                    {item.name ? (
                      <h3 className="fd-card__name">
                        <Multiline text={item.name} />
                      </h3>
                    ) : null}
                    {item.price ? <p className="fd-card__price">{item.price}</p> : null}
                    {item.cta_text && item.cta_link ? (
                      <Link to={item.cta_link} className="btn-primary">
                        {item.cta_text}
                      </Link>
                    ) : null}
                  </div>
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default HomeFeaturedDishes;
